export const columna = [

	

   {
		"nombre": "Noticias.",
		"imagen": 'noticias/lunescivismo.jpg',
	   "funcion": 'Homenaje a la bandera ',
		"url" : 'https://www.facebook.com/share/v/1HAF49fyyg/',
	},


	{
		"nombre": "Podcast.",
		"imagen": 'noticias/podcastnew.jpg',
	   "funcion": 'Podcast del Pueblo.',
		"url" : 'https://www.facebook.com/share/v/1ARG6hQcwV/',
	},

	
	{
		"nombre": "Noticias.",
		"imagen": 'noticias/sesenta.jpg',
	   "funcion": 'Video Semanal',
		"url" : 'https://www.facebook.com/share/v/1CJx9tNStB/',
	},

	// // {
	// 	"nombre": "Podcast del Pueblo",
	// 	"imagen": 'noticias/comisarios.jpg',
	// 	"funcion": '"Hidalgo Honesto"',
	// 	"url" : 'https://www.facebook.com/100064535929070/videos/755046710063599/?__so__=permalink&locale=es_LA',
	// },
		



]